import { combineReducers } from 'redux';
import { AlertesReducer } from './alertesReducer';

const alertes = combineReducers({
    alertes: AlertesReducer,
});

export default alertes;
